import { EventModel } from '@frontend/sports/betting-offer/feature/model';

import { MyBetsEventModel } from '../../my-bets/models/my-bets-event.model';
import { ScoreboardViewModel } from './scoreboard.viewmodel';

export class ScoreboardTournamentGameViewModel extends ScoreboardViewModel {
    constructor() {
        super();
        this.eventName = '';
    }

    eventName: string;

    protected override __fillFromEvent(event: EventModel | MyBetsEventModel): void {
        super.__fillFromEvent(event);
        this.eventName = event.name;
    }
}
